export default __webpack_public_path__ + "static/media/delete.f2d75026.svg";